import * as React from "react";
import type { SVGProps } from "react";

const PlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props} >
  <path d="M18.3405 7.79512C20.1087 8.75669 20.1087 11.2459 18.3405 12.2075L7.66386 18.0134C5.94531 18.9479 3.83334 17.7316 3.83334 15.8072L3.83334 4.19538C3.83334 2.27104 5.9453 1.05465 7.66385 1.9892L18.3405 7.79512Z" fill="#252525"/>
</svg>
);
export default PlayIcon;
